import { useState } from 'react';

export interface TabApi {
  tabValue: number;
  handleTabChange: (newValue: number) => void;
  isSelected: (indexOfTab: number) => boolean;
}

export const useTabs = (initialTabValue = 0): TabApi => {
  const [tabValue, setTabValue] = useState<number>(initialTabValue);

  const handleTabChange = (newValue: number) => {
    setTabValue(newValue);
  };

  function isSelected(indexOfTab: number): boolean {
    return indexOfTab === tabValue;
  }

  return {
    tabValue,
    handleTabChange,
    isSelected,
  };
};
